import { Breadcrumb, IconButton } from 'components'
import { useState } from 'react'

function AccordionItem({ children, path = [], liStyle = {}, style = {}, textStyle = {} }) {
  const [open, setOpen] = useState(false)

  return (
    <li className={open ? 'active' : ''} style={liStyle}>
      <div className="accordion-head title-border-box" style={style}>
        <Breadcrumb data={path} textStyle={textStyle} />
        <IconButton className="accordion" size="20" onClick={() => setOpen(!open)} />
      </div>
      {open && <div className="accordion-body">{children}</div>}
    </li>
  )
}

export default AccordionItem
